import moment from 'moment';
import { useState } from 'react';
import useClickOutside from '../../../../useClickOutside';
import { format } from 'date-fns';

export const ColumnSupply = (translate, warning, handleEdit, langLocal) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row?.supplier?.first_name}{' '}{row?.supplier?.last_name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('material')}</span>, sortable: true,
            cell: (row) => (
                <span>{row?.material?.name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('qty')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['qty']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('cost')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['cost']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('currency')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['currency']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('date')}</span>, 
            sortable: true,
            cell: (row) => (
                <span>{format(new Date(row['date_of_supply']), 'dd-MM-yyyy')}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row,index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => {setOptions(!options);setRowId(index)}}  ></i>
                    {
                        options && index === row_id && (
                            <div ref={domNode} className='div-actions shadow_main' style={langLocal === 'ar' ? { left: '20px' } : { left: '-100px' }} >
                                <span onClick={(e) => handleEdit(e, row)} >{translate('edit')}</span>
                                <span onClick={() => warning(row)} >{translate('delete')}</span>
                                {/*<span>{translate('details')}</span>
                                <span>{translate('add_transaction')}</span>*/}
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}